define('notifications_order_promocodes.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('notifications_order_promocodes', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-view=\"Promocode.Notification\"></div>  ";
},"useData":true}, 'extensions/UnlockCommerce/APCO_Updated_Theme/23.1.3/', 'extensions/UnlockCommerce/APCO_Updated_Theme/23.1.3/', Handlebars);
});